import type { DeviceModel } from '../../types/deviceModel';
import { portRow, simpleLayout } from './layoutHelpers';

/** TP-Link EAP225 — 802.3af PD. */
export const eap225Model: DeviceModel = {
  equipmentId: 'tplink-eap225',
  selfDrawWatts: 12.6,
  powerInputs: [{ id: 'poe-in', kind: 'poe-in', portNumber: 1, face: 'front' }],
  layout: {
    simple: simpleLayout(
      portRow({
        count: 1,
        startNumber: 1,
        kind: 'rj45',
        speedsMbps: [10, 100, 1000],
        poeIn: { standards: ['802.3af', '802.3at'], voltageMin: 37, voltageMax: 57, maxWatts: 12.95 },
        y: 22,
      }),
      160,
      70
    ),
  },
};
